export default __webpack_public_path__ + "static/media/Columbian Financial Dark.e16cc0ce.svg";